import { useEffect, useState } from 'react';

const resolveAssets = () => {
  if (typeof window !== 'undefined') {
    const assets = window.BLUECURRENT_PORTFOLIO_MAP?.assets;
    if (Array.isArray(assets)) return assets;
  }
  return [];
};

const fetchProducts = () => Promise.resolve(resolveAssets());

export const useProducts = () => {
  const [products, setProducts] = useState(null);

  useEffect(() => {
    let isActive = true;
    fetchProducts().then((data) => {
      if (isActive) setProducts(data);
    });
    return () => {
      isActive = false;
    };
  }, []);

  return { products, isLoading: products === null };
};
